import { render, staticRenderFns } from "./newAuth.vue?vue&type=template&id=9726b06e&scoped=true&"
import script from "./newAuth.vue?vue&type=script&lang=js&"
export * from "./newAuth.vue?vue&type=script&lang=js&"
import style0 from "./newAuth.vue?vue&type=style&index=0&id=9726b06e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9726b06e",
  null
  
)

export default component.exports